<template>
    <div class="content-box">
      <div class="content" v-loading="loading">
        <div class="top">
            <el-form @submit.native.prevent>
                <el-form-item required label="定向包选择类型">
                    <ListCheck 
                        :list="ADD_PACKAGE_TYPE_LIST" v-model="selectTackageType"
                        :before-change="handleBeforeChange"
                    />
                </el-form-item>
            </el-form>
            <svg-icon icon-class='tip' class-name='tip-icon' />
                您可点击更新按钮重新获取最新的定向包列表，请勿频繁点击，更新后无数据请前往媒体确认。
                <UpdateTimeButton 
                type="primary" 
                plain 
                :date="updateTime"
                size="mini"
                @click="handleUpdateNameList"
            />
        </div>
        <div class="form-box">
            <template v-if="!isUnified">
                <el-form :model="formData" ref="formRef" label-width="200px" label-position="left">
                    <el-form-item 
                        v-for="item in appList" 
                        :label="item.app_name" 
                        :key="item.value" 
                        :prop="item.value+''"
                        :rules="[{ required: true, message: `请选择 ${item.app_name} 定向包`, trigger: 'blur' }]"
                    >
                        <ESelect 
                            v-model="formData[item.value]" 
                            :placeholder="item.label" style="width: 600px;"
                            filterable
                            clearable
                            multiple
                        >
                            <el-option 
                                v-for="option in packageList" 
                                :label="option.label" 
                                :value="option.value" 
                                :key="option.value" 
                            />
                        </ESelect>
                    </el-form-item>
                </el-form>
            </template>
           <template v-else>
                <el-form :model="formData" ref="formRef" label-width="200px" label-position="left">
                    <el-form-item label="统一定向包" prop="package_names">
                        <ESelect 
                            v-model="formData.package_names" 
                            placeholder="请选择定向包" style="width: 600px;"
                            filterable
                            clearable
                            multiple
                            :rules="[{ required: true, message: `请选择定向包`, trigger: 'blur' }]"
                        >
                            <el-option 
                                v-for="option in packageList" 
                                :label="option.label" 
                                :value="option.value" 
                                :key="option.value" 
                            />
                        </ESelect>
                    </el-form-item>
                </el-form>
           </template>
        </div>
        <div class="footer">
            <el-button @click="$emit('close')">取消</el-button>
            <el-button type="primary" @keydown.enter.native.prevent @click="onSubmit" :loading="saveLoaing">保存</el-button>
        </div>
      </div>
    </div>
</template>
  
<script>
    import UpdateTimeButton from '@/components/UpdateTimeButton'
    import { getTargetingPackageListApi , updatePackageListApi} from '@/api'
    import ListCheck from '../../components/wkListCheck.vue'
    import { ADD_PACKAGE_TYPE_LIST, ADD_PACKAGE_TYPE } from '../../constant'
    export default {
        name: 'TargetedPackageDrawer',
        props: [ 'appList', 'account', 'objectiveType', 'cbs', 'configOpt', 'defaultData', 'selectType'],
        components: { UpdateTimeButton, ListCheck },
        data() {
            const defaultData = this.defaultData || {};
            return {
                ADD_PACKAGE_TYPE_LIST,
                selectTackageType: this.selectType,
                packageList: [],
                formData: defaultData,
                saveLoaing: false,
                updateTime: 0,
                loading: false,
            }
        },
        created() {
            this.getPackageList()
        },
        computed: {
            isUnified() {
                return this.selectTackageType === ADD_PACKAGE_TYPE.UNIFIED;
            }
        },
        methods: {
            handleBeforeChange({ newValue, oldValue }, cb) {
                return new Promise((resolve, reject) => {
                    this.$confirm('切换后已经修改的内容不会保存，确认要切换吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.formData = {};
                        cb();
                        resolve()
                    }).catch(reject);
                })
            },
            async getPackageList() {
                const params = {
                    account_id: this.account,
                    plat_id: 11,
                    objective_type: this.objectiveType,
                }
                this.loading = true;
                const { data } = await getTargetingPackageListApi(params)
                this.packageList = data.list
                this.loading = false;
                    
            },
            async onSubmit() {
                await this.$refs.formRef.validate()
                console.log('onSubmit');
                this.cbs.onSubmit({ ...this.formData }, [...this.packageList], this.selectTackageType)
            },
            async handleUpdateNameList() {
                const vm = this.$notify({
                    title: '请求成功',
                    message: '正在更新，请稍等',
                    type: 'success'
                });
                const params = {
                    account_id: this.account,
                    plat_id: 11,
                }
                try {
                    await updatePackageListApi(params);
                    this.$notify({
                        title: '更新成功',
                        message: '定向包 更新成功',
                        type: 'success'
                    });
                    this.getPackageList()
                } catch (error) {
                    if (typeof error.data === "number" && error.data>0) {
                        this.updateTime = error.data;
                    }
                    this.$notify({
                        title: '更新失败',
                        message: error.info || '定向包 更新失败',
                        type: 'error'
                    });
                    console.log('转化跟踪更新失败',error);
                }
                if (vm) {
                    vm.close()
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
.content-box {
  height: 100%;
  width: 100%;
  overflow-x: auto;
}
.content {
  padding: 0 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 1200px;
  .tip {
    margin-bottom: 10px;
  }
  .form-box {
    height: 0;
    flex: 1;
    overflow: auto;
    // background: red;
    margin-top: 16px;
  }
  .footer {
    height: 60px;
    line-height: 60px;
    text-align: right;
    padding-right: 80px;
    margin: 0 -20px;
    box-shadow: 4px 0 4px #ccc;
  }
}
</style>